import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ROLES } from "../../constants/UserRoles";
import Loader from "../../components/Loader";
import { Segmented } from "antd";
import ManageStudents from "../../components/orgAdmin/mockInterview/manageInterview/ManageStudents";
import InterviewDetails from "../../components/orgAdmin/mockInterview/manageInterview/InterviewDetails";
import { useParams, useSearchParams } from "react-router-dom";

function OrgAdminManageInterview() {
   const [searchParams] = useSearchParams();

  const jdIdentifier = searchParams.get("jdIdentifier");
  const iDronaId = searchParams.get("iDronaId");
  const [loading, setLoading] = useState(false);
  const [basicGuideDetails, setBasicGuideDetails] = useState(null);

  const [selectedTab, setSelectedTab] = useState("manage");

  return (
    <>
      {loading && <Loader />}

      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="mockInterviews" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="mockInterviews"
            userRole={ROLES.org_admin}
            newTitle={`Mock Interview`}
          />
          <div className="px-5 mt-4">
            <Segmented
              options={[
                { label: "Manage Students", value: "manage" },
                { label: "Interview Details", value: "interview" },
              ]}
              value={selectedTab}
              onChange={(e) => setSelectedTab(e)}
              block
              className="w-full max-w-[350px]"
              size="large"
            />
            {selectedTab === "manage" && (
              <ManageStudents
                setLoading={setLoading}
                iDronaId={iDronaId}
              />
            )}
            {selectedTab === "interview" && <InterviewDetails />}
          </div>
        </div>
      </div>
    </>
  );
}

export default OrgAdminManageInterview;
